<template>
    <VueFinalModal v-model="showModal3" classes="modal-container" content-class="modal-content4">

        <pacientes para-certificado @datos-seleccionados="handleDatosSeleccionados3" />

    </VueFinalModal>

    <VueFinalModal v-model="showModal4" classes="modal-container" content-class="modal-content4">

        <cie-diez @datos-seleccionados-cie10="handleDatosCie10" />

    </VueFinalModal>

    <div class="card mt-3" style="margin-bottom:10px">
        <div class="card-body">
            <div class="row">
                <!-- Encabezado mejorado -->
                <div class="col-12 mb-4">
                    <div class="d-flex justify-content-between align-items-center p-3" 
                         style="background: linear-gradient(135deg, #0078be 0%, #005a8b 100%); border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-shield-alt text-white me-3" style="font-size: 24px;"></i>
                            <h5 class="text-white mb-0 fw-bold">EMISIÓN DE CERTIFICADO SEGURO IESS</h5>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="bg-white rounded p-2 me-3" style="min-width: 200px; position: relative;">
                                <label for="fechaEmision" class="form-label mb-1" style="font-size: 11px; color: #0078be; font-weight: 600;">
                                    <i class="fas fa-calendar-alt me-1"></i>Fecha de Emisión
                                </label>
                                <div class="position-relative">
                                    <input type="date" id="fechaEmision" class="form-control form-control-sm border-0" 
                                           v-model="fechaEmision" style="font-size: 11px; color: #333; padding-right: 35px;" />
                                    <i class="fas fa-calendar-alt position-absolute" 
                                       style="right: 10px; top: 50%; transform: translateY(-50%); color: #0078be; cursor: pointer; font-size: 13px; z-index: 10;"
                                       @click="openDatePicker('fechaEmision')"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Información del paciente mejorada -->
                <div class="col-12 mb-4">
                    <div class="card border-0" style="background: #f8f9fa; border-radius: 12px;">
                        <div class="card-body p-4">
                            <h6 class="text-muted mb-3" style="font-size: 11px; font-weight: 600;">
                                <i class="fas fa-user-circle me-2"></i>INFORMACIÓN DEL PACIENTE
                            </h6>
                            <div class="row g-3">
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div class="d-flex align-items-center p-2 bg-white rounded">
                                        <div class="flex-grow-1">
                                            <small class="text-muted d-block" style="font-size: 9px;">DNI</small>
                                            <span class="fw-bold" style="color: #0078be;">{{ pacientes.cedula || 'No seleccionado' }}</span>
                                        </div>
                                        <i @click="loadModal" class="fas fa-search text-primary ms-2"
                                           style="cursor: pointer; font-size: 11px; transition: all 0.3s ease;"
                                           @mouseover="$event.target.style.transform='scale(1.2)'"
                                           @mouseout="$event.target.style.transform='scale(1)'"></i>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-5 mb-3">
                                    <div class="p-2 bg-white rounded">
                                        <small class="text-muted d-block" style="font-size: 9px;">NOMBRES</small>
                                        <span class="fw-bold" style="color: #333;">{{ pacientes.nombres || 'No seleccionado' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-3">
                                    <div class="p-2 bg-white rounded">
                                        <small class="text-muted d-block" style="font-size: 9px;">EDAD</small>
                                        <span class="fw-bold" style="color: #333;">{{ pacientes.edad || 'No seleccionado' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <!-- Información de la empresa mejorada -->
                <div class="col-12 mb-4">
                    <div class="card border-0" style="background: #f8f9fa; border-radius: 12px;">
                        <div class="card-body p-4">
                            <h6 class="text-muted mb-3" style="font-size: 11px; font-weight: 600;">
                                <i class="fas fa-building me-2"></i>INFORMACIÓN LABORAL Y EMPRESARIAL
                            </h6>
                            <div class="row g-3">
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div class="form-floating">
                                        <input 
                                            ref="tipoContingencia"
                                            type="text" 
                                            class="form-control form-control-sm" 
                                            v-model="empresa.tipoContingencia"
                                            placeholder="Tipo de contingencia" 
                                            autocomplete="off">
                                        <label for="tipoContingencia">Tipo de contingencia *</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div class="form-floating">
                                        <input 
                                            ref="empresaInput"
                                            type="text" 
                                            class="form-control form-control-sm" 
                                            id="empresa"
                                            v-model="empresa.empresa" 
                                            placeholder="Empresa" 
                                            autocomplete="off">
                                        <label for="empresa">Empresa *</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div class="form-floating">
                                        <input 
                                            ref="cargoInput"
                                            type="text" 
                                            class="form-control form-control-sm" 
                                            v-model="empresa.cargo"
                                            placeholder="Cargo" 
                                            autocomplete="off">
                                        <label for="cargo">Cargo *</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div class="form-floating">
                                        <input type="text" class="form-control form-control-sm" disabled v-model="pacientes.cedula"
                                            placeholder="Historia Clínica" autocomplete="off">
                                        <label for="historiaClinica">Historia Clínica *</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-floating">
                                        <input 
                                            ref="celularInput"
                                            type="tel" 
                                            class="form-control form-control-sm" 
                                            v-model="empresa.celular"
                                            placeholder="Celular" 
                                            autocomplete="off">
                                        <label>Celular *</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-floating">
                                        <input 
                                            ref="emailInput"
                                            type="email" 
                                            class="form-control form-control-sm" 
                                            v-model="empresa.email"
                                            placeholder="Email" 
                                            autocomplete="off">
                                        <label>Email</label>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-floating">
                                        <input 
                                            ref="direccionInput"
                                            type="text" 
                                            class="form-control form-control-sm" 
                                            v-model="empresa.direccion"
                                            placeholder="Dirección" 
                                            autocomplete="off">
                                        <label>Dirección *</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Antecedentes mejorados -->
                <div class="col-12 mb-4">
                    <div class="card border-0" style="background: #f8f9fa; border-radius: 12px;">
                        <div class="card-body p-4">
                            <h6 class="text-muted mb-3" style="font-size: 11px; font-weight: 600;">
                                <i class="fas fa-notes-medical me-2"></i>ANTECEDENTES MÉDICOS
                            </h6>
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="form-floating">
                                        <textarea 
                                            ref="antecedentesPersonales"
                                            class="form-control" 
                                            v-model="empresa.antecedentes_personales"
                                            placeholder="Antecedentes patológicos personales" 
                                            style="height: 100px"
                                            autocomplete="off">
                                        </textarea>
                                        <label>Antecedentes patológicos personales *</label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-floating">
                                        <textarea 
                                            ref="antecedentesQuirurgicos"
                                            class="form-control" 
                                            v-model="empresa.antecedentes_quirurgicos"
                                            placeholder="Antecedentes patológicos quirurgicos" 
                                            style="height: 100px"
                                            autocomplete="off">
                                        </textarea>
                                        <label>Antecedentes patológicos quirúrgicos *</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Botón CIE10 mejorado -->
                <div class="col-12 mb-4">
                    <div class="d-flex justify-content-center">
                        <button @click="cargaCie10" 
                                class="btn btn-primary px-4 py-2" 
                                style="background: linear-gradient(135deg, #eb1265 0%, #d4145a 100%); border: none; border-radius: 25px; box-shadow: 0 4px 15px rgba(235, 18, 101, 0.3); transition: all 0.3s ease; font-size: 11px;"
                                @mouseover="$event.target.style.transform='translateY(-2px)'"
                                @mouseout="$event.target.style.transform='translateY(0)'">
                            <i class="fas fa-plus-circle me-2"></i>
                            <span class="fw-bold">CARGAR DIAGNÓSTICOS CIE-10</span>
                        </button>
                    </div>
                </div>

                <!-- Tabla de diagnósticos mejorada -->
                <div v-if="cie10Seleccionados.length" class="col-12 mb-4">
                    <div class="card border-0" style="box-shadow: 0 2px 10px rgba(0,0,0,0.1); border-radius: 12px;">
                        <div class="card-header bg-white border-0 py-3" style="border-radius: 12px 12px 0 0;">
                            <h6 class="mb-0 text-center" style="color: #0078be; font-weight: 600; font-size: 11px;">
                                <i class="fas fa-list-alt me-2"></i>DIAGNÓSTICOS SELECCIONADOS
                            </h6>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-hover mb-0">
                                    <thead>
                                        <tr style="background: linear-gradient(135deg, #0078be 0%, #005a8b 100%); color: white;">
                                            <th class="text-center" style="border: none; padding: 12px; font-size: 11px; font-weight: 600;">
                                                <i class="fas fa-hashtag me-1"></i>CÓDIGO
                                            </th>
                                            <th style="border: none; padding: 12px; font-size: 11px; font-weight: 600;">
                                                <i class="fas fa-stethoscope me-1"></i>DIAGNÓSTICO
                                            </th>
                                            <th class="text-center" style="border: none; padding: 12px; font-size: 11px; font-weight: 600;">
                                                <i class="fas fa-trash me-1"></i>ACCIONES
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in cie10Seleccionados" :key="item.Codigo"
                                            style="border-bottom: 1px solid #f0f0f0;">
                                            <td class="text-center align-middle" style="padding: 10px; font-weight: 600; color: #0078be;">
                                                {{ item.Codigo }}
                                            </td>
                                            <td class="align-middle" style="padding: 10px; font-size: 11px;">
                                                {{ item.Descriptor }}
                                            </td>
                                            <td class="text-center align-middle" style="padding: 10px;">
                                                <button class="btn btn-outline-danger btn-sm rounded-circle"
                                                        @click="eliminarCie10(index)"
                                                        style="width: 28px; height: 28px; transition: all 0.3s ease;"
                                                        @mouseover="$event.target.style.transform='scale(1.1)'"
                                                        @mouseout="$event.target.style.transform='scale(1)'">
                                                    <i class="fas fa-times" style="font-size: 9px;"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Campos de fecha mejorados -->
                <div class="col-12 mb-4">
                    <div class="card border-0" style="background: #f8f9fa; border-radius: 12px;">
                        <div class="card-body p-4">
                            <h6 class="text-muted mb-3" style="font-size: 11px; font-weight: 600;">
                                <i class="fas fa-calendar-week me-2"></i>PERIODO DE REPOSO
                            </h6>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3">
                                    <label for="startDate" class="form-label" style="font-weight: 600; color: #0078be; font-size: 11px;">
                                        <i class="fas fa-calendar-plus me-1"></i>Fecha Inicial (*)
                                    </label>
                                    <div class="position-relative">
                                        <input type="date" id="startDate" class="form-control" 
                                               v-model="startDate" @change="validateDates"
                                               style="border-radius: 8px; border: 2px solid #e9ecef; transition: all 0.3s ease; padding-right: 40px; font-size: 11px;"
                                               @focus="$event.target.style.borderColor='#0078be'"
                                               @blur="$event.target.style.borderColor='#e9ecef'" />
                                        <i class="fas fa-calendar-alt position-absolute" 
                                           style="right: 12px; top: 50%; transform: translateY(-50%); color: #0078be; cursor: pointer; font-size: 13px; z-index: 10;"
                                           @click="openDatePicker('startDate')"></i>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6 mb-3">
                                    <label for="endDate" class="form-label" style="font-weight: 600; color: #0078be; font-size: 11px;">
                                        <i class="fas fa-calendar-minus me-1"></i>Fecha Final (*)
                                    </label>
                                    <div class="position-relative">
                                        <input type="date" id="endDate" class="form-control" 
                                               v-model="endDate" @change="validateDates"
                                               style="border-radius: 8px; border: 2px solid #e9ecef; transition: all 0.3s ease; padding-right: 40px; font-size: 11px;"
                                               @focus="$event.target.style.borderColor='#0078be'"
                                               @blur="$event.target.style.borderColor='#e9ecef'" />
                                        <i class="fas fa-calendar-alt position-absolute" 
                                           style="right: 12px; top: 50%; transform: translateY(-50%); color: #0078be; cursor: pointer; font-size: 13px; z-index: 10;"
                                           @click="openDatePicker('endDate')"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Botón de generar certificado mejorado -->
                <div class="col-12">
                    <div class="d-flex justify-content-center">
                        <button :disabled="!isDateRangeValid" @click="download" 
                                class="btn btn-lg px-5 py-3 fw-bold" 
                                :class="{ 'btn-success': isDateRangeValid, 'btn-secondary': !isDateRangeValid }"
                                style="border: none; border-radius: 50px; box-shadow: 0 6px 20px rgba(0,0,0,0.15); transition: all 0.3s ease; min-width: 250px; font-size: 12px;"
                                @mouseover="isDateRangeValid && ($event.target.style.transform='translateY(-3px)')"
                                @mouseout="isDateRangeValid && ($event.target.style.transform='translateY(0)')">
                            <i class="fas fa-file-pdf me-3" style="font-size: 15px;"></i>
                            <span v-if="isDateRangeValid">GENERAR CERTIFICADO</span>
                            <span v-else>COMPLETE TODOS LOS CAMPOS</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import Pacientes from "../Receta/Pacientes.vue";
import CieDiez from "../Certificados/Cie-10.vue";
import { generatePdfCertificadoV2 } from './Impresion-V2';

export default {
    name: "Certificados-Medicos-v2",
    components: {
        VueFinalModal,
        Pacientes,
        CieDiez
    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            showModal3: false,
            showModal4: false,
            pacientes: {
                fecha: '',
                cedula: '',
                nombres: '',
                edad: '',
                doctor: '',
                especialidad: ''
            },
            empresa: {
                tipoContingencia: '',
                empresa: '',
                cargo: '',
                celular: '',
                email: '',
                direccion: '',
                antecedentes_personales: '',
                antecedentes_quirurgicos: ''
            },
            cie10Seleccionados: [],
            isDateRangeValid: false,
            startDate: '',
            endDate: '',
            fechaEmision: new Date().toISOString().split('T')[0], // Fecha actual en formato YYYY-MM-DD
        };
    },
    computed: {},
    watch: {
        'empresa.tipoContingencia': function (newValue) {
            this.empresa.tipoContingencia = this.convertirAMayusculasSeguro('tipoContingencia', newValue);
        },
        'empresa.empresa': function (newValue) {
            this.empresa.empresa = this.convertirAMayusculasSeguro('empresaInput', newValue);
        },
        'empresa.cargo': function (newValue) {
            this.empresa.cargo = this.convertirAMayusculasSeguro('cargoInput', newValue);
        },
        'empresa.email': function (newValue) {
            this.empresa.email = this.convertirAMayusculasSeguro('emailInput', newValue);
        },
        'empresa.direccion': function (newValue) {
            this.empresa.direccion = this.convertirAMayusculasSeguro('direccionInput', newValue);
        },
        'empresa.antecedentes_personales': function (newValue) {
            this.empresa.antecedentes_personales = this.convertirAMayusculasSeguro('antecedentesPersonales', newValue);
        },
        'empresa.antecedentes_quirurgicos': function (newValue) {
            this.empresa.antecedentes_quirurgicos = this.convertirAMayusculasSeguro('antecedentesQuirurgicos', newValue);
        },
        'empresa.celular': function (newValue) {
            this.empresa.celular = this.convertirAMayusculasSeguro('celularInput', newValue);
        },
    },

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }
    },
    methods: {
        loadModal() {
            this.showModal3 = true
        },

        cargaCie10() {
            this.showModal4 = true
        },

        openDatePicker(inputId) {
            // Simular un clic en el input de fecha para abrir el datepicker
            const input = document.getElementById(inputId);
            if (input) {
                input.showPicker ? input.showPicker() : input.click();
            }
        },

        // Función helper para convertir a mayúsculas de manera segura
        convertirAMayusculasSeguro(refName, newValue) {
            const input = this.$refs[refName];
            if (!input) return newValue.toUpperCase();
            
            // Verificar si el input soporta setSelectionRange
            const inputType = input.type;
            const tiposNoSoportados = ['email', 'tel', 'number', 'date', 'time', 'datetime-local', 'month', 'week'];
            
            if (tiposNoSoportados.includes(inputType)) {
                // Para inputs que no soportan setSelectionRange, solo convertir a mayúsculas
                return newValue.toUpperCase();
            } else {
                // Para inputs que sí soportan setSelectionRange, mantener la posición del cursor
                const cursorPosition = input.selectionStart;
                this.$nextTick(() => {
                    try {
                        input.setSelectionRange(cursorPosition, cursorPosition);
                    } catch (error) {
                        // Si falla, simplemente ignorar el error
                        console.warn('No se pudo mantener la posición del cursor:', error);
                    }
                });
                return newValue.toUpperCase();
            }
        },

        handleDatosCie10(resp) {
            // Verificar si el código ya existe en la lista
            const existe = this.cie10Seleccionados.some(item => item.Codigo === resp.Codigo);

            // Limitar a máximo 4 diagnósticos
            if (this.cie10Seleccionados.length >= 4) {
                this.$swal.fire({
                    title: "Límite alcanzado",
                    text: "Solo se permiten máximo 4 diagnósticos para mantener el formato de una página",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
                return;
            }

            if (!existe) {
                this.cie10Seleccionados.push(resp);
                this.showModal4 = false; // Cerrar el modal después de agregar
            } else {
                this.$swal.fire({
                    title: "Advertencia",
                    text: "Este código CIE10 ya ha sido agregado",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
            }
        },

        handleDatosSeleccionados3(resp) {

            if (resp && resp.cedula !== undefined && resp.cedula !== '') {

                const formatter = new Intl.DateTimeFormat('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });

                this.pacientes = {
                    cedula: resp.cedula,
                    nombres: resp.nombres_pacientes,
                    edad: this.calcularEdad(resp.nacimiento),
                    fecha: formatter.format(new Date())
                };

                this.showModal3 = false
            }

        },

        eliminarCie10(index) {
            this.$swal.fire({
                title: "¿Está seguro?",
                text: "¿Desea eliminar este diagnóstico?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-secondary ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.cie10Seleccionados.splice(index, 1);
                }
            });
        },

        validateDates() {
            if (!this.startDate || !this.endDate) {
                this.isDateRangeValid = false;
                return;
            }

            if (this.startDate > this.endDate) {
                alert("La fecha inicial no puede ser mayor que la fecha final.");
                this.isDateRangeValid = false;
            } else {
                this.isDateRangeValid = true;
            }
        },

        convertirFechaALetras(fecha) {
            const meses = [
                "enero", "febrero", "marzo", "abril", "mayo", "junio",
                "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
            ];

            const numeros = {
                1: "uno", 2: "dos", 3: "tres", 4: "cuatro", 5: "cinco", 6: "seis", 7: "siete",
                8: "ocho", 9: "nueve", 10: "diez", 11: "once", 12: "doce", 13: "trece",
                14: "catorce", 15: "quince", 16: "dieciséis", 17: "diecisiete", 18: "dieciocho",
                19: "diecinueve", 20: "veinte", 21: "veintiuno", 22: "veintidós", 23: "veintitrés",
                24: "veinticuatro", 25: "veinticinco", 26: "veintiséis", 27: "veintisiete",
                28: "veintiocho", 29: "veintinueve", 30: "treinta", 31: "treinta y uno"
            };

            const [año, mes, dia] = fecha.split("-").map(Number);

            function convertirAño(año) {
                const unidades = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
                const decenas = ["", "diez", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
                const centenas = ["", "cien", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];

                if (año === 2000) return "dos mil";
                if (año > 2000 && año < 2010) return `dos mil ${numeros[año % 100]}`;
                if (año >= 2010 && año < 2020) return `dos mil ${decenas[Math.floor((año % 100) / 10)]}${año % 10 !== 0 ? " y " + unidades[año % 10] : ""}`;
                return `dos mil ${numeros[año % 100]}`;
            }

            return `${numeros[dia]} de ${meses[mes - 1]} de ${convertirAño(año)}`;
        },

        async download() {

            // Validar que haya un paciente seleccionado
            if (!this.pacientes.cedula || !this.pacientes.nombres) {
                this.$swal.fire({
                    title: "Datos incompletos",
                    text: "Debe seleccionar un paciente",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
                return;
            }

            // Validar campos de empresa
            const camposRequeridos = {
                tipoContingencia: 'Tipo de contingencia',
                empresa: 'Empresa',
                cargo: 'Cargo',
                celular: 'Celular',
                direccion: 'Dirección',
                antecedentes_personales: 'Antecedentes patológicos personales',
                antecedentes_quirurgicos: 'Antecedentes patológicos quirúrgicos'
            };

            for (const [campo, nombre] of Object.entries(camposRequeridos)) {
                if (!this.empresa[campo]?.trim()) {
                    this.$swal.fire({
                        title: "Datos incompletos",
                        text: `El campo ${nombre} es obligatorio`,
                        icon: "warning",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                        buttonsStyling: false,
                    });
                    return;
                }
            }

            // Validar formato de email solo si se ha ingresado
            if (this.empresa.email?.trim()) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.empresa.email.toLowerCase())) {
                    this.$swal.fire({
                        title: "Formato inválido",
                        text: "Por favor ingrese un email válido",
                        icon: "warning",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                        buttonsStyling: false,
                    });
                    return;
                }
            }

            // Validar formato de celular (10 dígitos)
            const celularRegex = /^\d{10}$/;
            if (!celularRegex.test(this.empresa.celular)) {
                this.$swal.fire({
                    title: "Formato inválido",
                    text: "El número de celular debe tener 10 dígitos",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
                return;
            }

            // Validar que haya al menos un diagnóstico CIE10
            if (this.cie10Seleccionados.length === 0) {
                this.$swal.fire({
                    title: "Datos incompletos",
                    text: "Debe seleccionar al menos un diagnóstico CIE10",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
                return;
            }

            // Validar que las fechas estén seleccionadas
            if (!this.startDate || !this.endDate) {
                this.$swal.fire({
                    title: "Datos incompletos",
                    text: "Debe seleccionar las fechas inicial y final",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
                return;
            }

            if (this.isDateRangeValid) {
                const fechaInicial = this.formatearFecha(this.startDate);
                const fechaFinal = this.formatearFecha(this.endDate);

                let datos = JSON.parse(localStorage.getItem("userData"));
                this.pacientes.doctor = datos.displayName;
                this.pacientes.especialidad = datos.especialidad;

                // Formatear la fecha de emisión para el paciente
                const formatter = new Intl.DateTimeFormat('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                
                // Usar la fecha de emisión seleccionada o la fecha actual si no se seleccionó
                const fechaEmision = this.fechaEmision || new Date().toISOString().split('T')[0];
                const fechaEmisionFormateada = formatter.format(new Date(fechaEmision));
                
                // Actualizar la fecha del paciente con la fecha de emisión seleccionada
                this.pacientes.fecha = fechaEmisionFormateada;

                // Crear objeto con todos los datos necesarios
                const certificadoData = {
                    paciente: this.pacientes,
                    diagnosticos: this.cie10Seleccionados,
                    fechaInicial: fechaInicial,
                    fechaFinal: fechaFinal,
                    fechaEmision: fechaEmision,
                    doctor: this.pacientes.doctor,
                    doctor_dni: datos.cedula,
                    especialidad: this.pacientes.especialidad,
                    empresa: this.empresa,
                    startDate: this.startDate,
                    endDate: this.endDate
                };

                let textAletraFechaInicial = this.convertirFechaALetras(this.startDate)
                let textAletraFechaFinal = this.convertirFechaALetras(this.endDate)

                // Aquí puedes continuar con la lógica de descarga del certificado
                await generatePdfCertificadoV2(certificadoData, textAletraFechaInicial, textAletraFechaFinal, this.startDate, this.endDate, datos.email, datos.movil);

            } else {
                this.$swal.fire({
                    title: "Rango de fechas inválido",
                    text: "La fecha inicial no puede ser mayor que la fecha final",
                    icon: "warning",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                    buttonsStyling: false,
                });
            }
        },


    }



}



</script>


<style scoped>
.form-floating>label {
    font-size: 11px;
    color: #6c757d;
}

.form-floating>.form-control {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
    height: calc(3rem + 2px);
}

.form-floating>.form-control::placeholder {
    color: transparent;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown) {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
}

.form-floating>.form-control-sm {
    height: calc(2.5rem + 2px);
    padding: 1rem 0.75rem;
    font-size: 0.875rem;
}

.form-floating>textarea.form-control {
    height: 100px;
    min-height: 100px;
    padding-top: 1.625rem;
}

.form-floating>textarea.form-control:focus,
.form-floating>textarea.form-control:not(:placeholder-shown) {
    padding-top: 2rem;
}

/* Estilos personalizados para mejorar la apariencia */
.card {
    border: none;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    border-radius: 16px;
}

.form-control:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 120, 190, 0.25);
    border-color: #0078be;
}

.btn {
    font-weight: 600;
    letter-spacing: 0.5px;
}

.btn-success {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
}

.btn-success:hover {
    background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
    transform: translateY(-2px);
}

.btn-secondary {
    background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
    border: none;
}

/* Animaciones suaves */
.table-hover tbody tr:hover {
    background-color: rgba(0, 120, 190, 0.05);
    transform: scale(1.01);
    transition: all 0.2s ease;
}

/* Efectos de hover para iconos */
.fas {
    transition: all 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .card-body {
        padding: 1rem;
    }
    
    .btn-lg {
        padding: 0.75rem 1.5rem;
        font-size: 11px;
    }
    
    h6 {
        font-size: 11px !important;
    }
    
    .form-label {
        font-size: 10px !important;
    }
    
    .form-control {
        font-size: 10px !important;
    }
    
    small {
        font-size: 8px !important;
    }
    
    span {
        font-size: 10px !important;
    }
    
    /* Mejoras específicas para el encabezado en móviles */
    .d-flex.justify-content-between.align-items-center {
        flex-direction: column !important;
        gap: 1rem;
    }
    
    .d-flex.justify-content-between.align-items-center .bg-white {
        min-width: 100% !important;
        width: 100% !important;
    }
    
    .d-flex.justify-content-between.align-items-center h5 {
        font-size: 14px !important;
        text-align: center;
    }
    
    .d-flex.justify-content-between.align-items-center .fas.fa-shield-alt {
        font-size: 20px !important;
    }
}

@media (max-width: 576px) {
    .d-flex.justify-content-between.align-items-center h5 {
        font-size: 12px !important;
    }
    
    .d-flex.justify-content-between.align-items-center .bg-white {
        padding: 0.75rem !important;
    }
    
    .d-flex.justify-content-between.align-items-center .form-label {
        font-size: 9px !important;
    }
    
    .d-flex.justify-content-between.align-items-center input[type="date"] {
        font-size: 10px !important;
    }
}

/* Mejoras para el campo de fecha en el encabezado */
input[type="date"] {
    cursor: pointer;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
    display: none;
}

/* Estilo para los iconos de calendario */
.fa-calendar-alt {
    transition: all 0.3s ease;
}

/* Efecto hover en los campos de fecha */
.position-relative:hover .fa-calendar-alt {
    color: #005a8b !important;
    transform: translateY(-50%) scale(1.1);
}

/* Efecto hover directo en el icono */
.fa-calendar-alt:hover {
    color: #005a8b !important;
    transform: translateY(-50%) scale(1.2);
}

/* Mejora del focus en campos de fecha */
input[type="date"]:focus + .fa-calendar-alt {
    color: #005a8b !important;
}

/* Efecto de sombra para las tarjetas de información */
.card.border-0 {
    transition: all 0.3s ease;
}

.card.border-0:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.12);
}

/* Tamaños de fuente más pequeños para toda la aplicación */
.table th,
.table td {
    font-size: 11px;
}

.btn-sm {
    font-size: 9px;
    padding: 0.25rem 0.5rem;
}

.form-control-sm {
    font-size: 9px;
}

/* Ajustes para iconos más pequeños */
.fas {
    font-size: 11px;
}

.fa-calendar-alt {
    font-size: 13px;
}

.fa-search {
    font-size: 11px;
}

.fa-times {
    font-size: 9px;
}

/* Ajustes para labels y textos pequeños */
.form-label {
    font-size: 11px;
}

small {
    font-size: 9px;
}

/* Ajustes para títulos */
h6 {
    font-size: 11px;
}

/* Ajustes para botones principales */
.btn-lg {
    font-size: 12px;
}

/* Ajustes para inputs de fecha */
input[type="date"] {
    font-size: 11px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .card-body {
        padding: 1rem;
    }
    
    .btn-lg {
        padding: 0.75rem 1.5rem;
        font-size: 11px;
    }
    
    h6 {
        font-size: 11px !important;
    }
    
    .form-label {
        font-size: 10px !important;
    }
    
    .form-control {
        font-size: 10px !important;
    }
    
    small {
        font-size: 8px !important;
    }
    
    span {
        font-size: 10px !important;
    }
}
</style>
